//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin } from "ckeditor5";
import AkLinkImageEditing from "./akLinkImageEditing";
import AkLinkImageUi from "./akLinkImageUi";

export default class AkLinkImage extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [AkLinkImageEditing, AkLinkImageUi];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "AkLinkImage";
  }
}
